'use strict'

import Swiper from 'swiper'
import {Navigation, Pagination} from 'swiper/modules'
import {rotator} from "../scripts/components/Rotator.js";

const siblingsGallerySelector = '[data-swiper="service-detail-slider"]'
new Swiper(siblingsGallerySelector, {
  modules: [Navigation, Pagination],

  breakpoints: {
    320: {
      spaceBetween: 8,
      slidesPerView: 1.1
    },
    568: {
      spaceBetween: 16,
      slidesPerView: 1.5
    },
    992: {
      spaceBetween: 24,
      slidesPerView: 2
    }
  },

  pagination: {
    el: `${siblingsGallerySelector} + .row .swiper-pagination`,
    type: 'progressbar'
  },

  navigation: {
    nextEl: `${siblingsGallerySelector} + .row .swiper-button-next`,
    prevEl: `${siblingsGallerySelector} + .row .swiper-button-prev`
  }
})

const rotatorElement = document.querySelector('.rotator') || false
if (rotatorElement) new rotator(rotatorElement)
